import axios from "axios";
import { encryptData, decryptData } from "./encryptionHelper";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const token = sessionStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      if (config.data && !config._isEncrypted) {
        const encryptedPayload = encryptData(config.data);
        if (encryptedPayload.iv || !config.data.iv) {
          config.data = encryptedPayload;
        }
      }
    } catch (error) {
      console.error("Request encryption error:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Decrypt response payload
axiosInstance.interceptors.response.use(
  (response) => {
    try {
      // Check for token expiration BEFORE trying to decrypt
      // The server may return { encrypted: true, error: true, message: "Token expired..." }
      if (response.data && response.data.error === true && 
          response.data.message?.includes("Token expired")) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        window.location.href = "/login";
      }

      // Then try to decrypt if encrypted
      if (response.data && response.data.encrypted) {
        response.data = decryptData(response.data);
      }
    } catch (error) {
      console.error("Response decryption error:", error);
    }
    return response;
  },
  (error) => {
    try {
      // Handle 401 Unauthorized - Token expired
      if (error.response && error.response.status === 401) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        // Use window.location for navigation since we're outside React context
        window.location.href = "/login";
      }

      // Check for token expired in error response data before decrypting
      if (error.response && error.response.data && 
          error.response.data.error === true && 
          error.response.data.message?.includes("Token expired")) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        window.location.href = "/login";
      }

      // Decrypt error response if it's encrypted
      if (
        error.response &&
        error.response.data &&
        error.response.data.encrypted
      ) {
        error.response.data = decryptData(error.response.data);
      }
    } catch (decryptError) {
      console.error("Error response decryption failed:", decryptError);
    }
    return Promise.reject(error); // still reject so catch() runs
  }
);

export default axiosInstance;

// =============================================

// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
//   // timeout: 2000,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
// });

// // Add a request interceptor
// axiosInstance.interceptors.request.use(
//   (config) => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (token) {
//         config.headers["Authorization"] = `Bearer ${token}`;
//       }
//     } catch (error) {
//       console.error("Error retrieving token from sessionStorage:", error);
//     }
//     return config;
//   },
//   (error) => {
//     // Do something with request error
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;
